"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChapterWithContentResponseModel = void 0;
const core = __importStar(require("../../core"));
const ChapterWithContentResponseModelState_1 = require("./ChapterWithContentResponseModelState");
const ChapterStatisticsResponse_1 = require("./ChapterStatisticsResponse");
const ChapterContentResponseModel_1 = require("./ChapterContentResponseModel");
exports.ChapterWithContentResponseModel = core.serialization.object({
    chapterId: core.serialization.property("chapter_id", core.serialization.string()),
    name: core.serialization.string(),
    lastConversionDateUnix: core.serialization.property("last_conversion_date_unix", core.serialization.number().optional()),
    conversionProgress: core.serialization.property("conversion_progress", core.serialization.number().optional()),
    canBeDownloaded: core.serialization.property("can_be_downloaded", core.serialization.boolean()),
    state: ChapterWithContentResponseModelState_1.ChapterWithContentResponseModelState,
    hasVideo: core.serialization.property("has_video", core.serialization.boolean().optional()),
    statistics: ChapterStatisticsResponse_1.ChapterStatisticsResponse.optional(),
    lastConversionError: core.serialization.property("last_conversion_error", core.serialization.string().optional()),
    content: ChapterContentResponseModel_1.ChapterContentResponseModel,
});
